import { graphql, useStaticQuery } from 'gatsby';

export interface Icon {
    color: {
        value: {
            codename: string;
        }[];
    };
    icon_svg_file: {
        value: {
            url: string;
            description: string;
        }[];
    };
    wellness_type: {
        value: {
            name: string;
            codename: string;
        }[];
    };
    blog_topic: {
        value: {
            name: string;
            codename: string;
        }[];
    };
}

export interface IconNode {
    node: {
        elements: Icon;
    };
}

interface IconQuery {
    allKontentItemMediaIcon: {
        edges: IconNode[];
    };
}

export const useIcons = (): IconNode[] => {
    const icons: IconQuery = useStaticQuery(graphql`
        {
            allKontentItemMediaIcon(
                filter: { system: { workflow_step: { ne: "archived" } } }
            ) {
                edges {
                    node {
                        elements {
                            color {
                                value {
                                    codename
                                }
                            }
                            icon_svg_file {
                                value {
                                    url
                                    description
                                }
                            }
                            wellness_type {
                                value {
                                    codename
                                    name
                                }
                            }
                            blog_topic {
                                value {
                                    codename
                                    name
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return icons.allKontentItemMediaIcon.edges;
};
